export enum DecisionState {
    NO_DECISION,
    PRE_DECISION,
    NOW_DECISION,
    FOLLOW_DECISION,
}

export enum DecisionType {
    None,
    Hit,
    Stand,
    Surrender,
    Split,
    DoubleDown,
    Insurance,
}

export enum DecisionCommandType {
    None,
    Pre_decision,
    Decision,
    FollowDecision,
}
